import { SUPPLIERS as LABELS } from './labels.js';

export default {
  data: [],
  page: {
    currentPage: 1,
    total: 0,
    pageSize: 10
  },
  option: {
    refreshBtn: false,
    indexLabel: LABELS.serialNumber,
    indexFixed: false,
    searchShow: false,
    searchBtn: true,
    columnBtn: false,
    align: 'center',
    menu: false,
    border: true,
    highlightCurrentRow: true,
    selection: true,
    stripe: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    index: true,
    sortable: true,
    tip: false,
    indeterminate: true,
    labelPosition: 'top',
    searchSpan: 12,
    searchMenuSpan: 12,
    column: [
      {
        label: LABELS.supplierAccount,
        prop: 'toElsAccount',
        overHidden: true,
        width: 200,
        search: true,
        searchSpan: 8
      },
      {
        label: LABELS.supplierName,
        prop: 'toElsAccountName',
        overHidden: true,
        // supplierName
        search: true,
        searchSpan: 16
      }
    ]
  }
};
